(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 3057:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(7294);

function ArrowRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

module.exports = ArrowRightIcon;

/***/ }),

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9413);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./src/components/slider/dot.tsx



var Dot = function(param) {
    var active = param.active, count = param.count, handleClick = param.handleClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        id: "dot-" + count,
        "data-target": count + 1,
        onClick: handleClick,
        className: (0,clsx_m/* default */.Z)("dot rounded bg-gray-300 border border-solid border-primary-main w-5 h-5 mx-4 cursor-pointer transition duration-200 hover:bg-primary-main active:bg-primary-main", active && "bg-primary-main"),
        "aria-label": (0,clsx_m/* default */.Z)("dot-".concat(count))
    }));
};
/* harmony default export */ var dot = (Dot);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 153 modules
var motion = __webpack_require__(1203);
;// CONCATENATED MODULE: ./src/components/slider/sliderTopSVG.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var lines = [
    {
        id: 1,
        x: 435,
        y: 435,
        translate: {
            x: 1090,
            y: 0
        },
        rotate: true
    },
    {
        id: 2,
        x: 369,
        y: 369,
        translate: {
            x: 417,
            y: 0
        },
        rotate: true
    }
];
var animateIn = {
    hidden: {
        strokeDashoffset: 100
    },
    visible: {
        strokeDashoffset: 0,
        transition: {
            delay: 1.1
        }
    }
};
var SliderTopSVG = function(_param) {
    var rotation = _param.rotation, show = _param.show, props = _objectWithoutProperties(_param, [
        "rotation",
        "show"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", _objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1520 1080"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            children: lines.map(function(line, i) {
                var transform;
                if (line.rotate) {
                    transform = "translate(" + line.translate.x + " " + line.translate.y + ") rotate(" + rotation + " " + line.x / 2 + " " + line.y / 2 + ")";
                } else {
                    transform = "translate(" + line.translate.x + " " + line.translate.y + ")";
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, {
                    className: (0,clsx_m/* default */.Z)("stroke-current text-primary-main stroke-3"),
                    variants: animateIn,
                    initial: "hidden",
                    animate: show ? "visible" : "hidden",
                    pathLength: "100",
                    strokeDasharray: "100",
                    transition: {
                        duration: 0.5
                    },
                    fill: "none",
                    x2: line.x,
                    y2: line.y,
                    transform: transform
                }, i));
            })
        })
    })));
};
/* harmony default export */ var sliderTopSVG = (SliderTopSVG);

;// CONCATENATED MODULE: ./src/components/slider/sliderBottomSVG.tsx




function sliderBottomSVG_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliderBottomSVG_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliderBottomSVG_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sliderBottomSVG_objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = sliderBottomSVG_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function sliderBottomSVG_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var sliderBottomSVG_lines = [
    {
        id: 3,
        x: 701,
        y: 701,
        translate: {
            x: 0,
            y: 410
        },
        rotate: true
    },
    {
        id: 4,
        x: 921,
        y: 921,
        rotate: true,
        translate: {
            x: 0,
            y: 190
        }
    },
    {
        id: 5,
        x: 411,
        y: 411,
        translate: {
            x: 1086,
            y: 669
        },
        rotate: true
    },
    {
        id: 6,
        x: 207,
        y: 207,
        translate: {
            x: 1008,
            y: 873
        },
        rotate: false
    }
];
var sliderBottomSVG_animateIn = {
    hidden: {
        strokeDashoffset: 100
    },
    visible: {
        strokeDashoffset: 0,
        transition: {
            delay: 1.1
        }
    }
};
var fadeIn = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            delay: 1.1
        }
    }
};
var SliderBottomSVG = function(_param) {
    var rotation = _param.rotation, show = _param.show, props = sliderBottomSVG_objectWithoutProperties(_param, [
        "rotation",
        "show"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", sliderBottomSVG_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1520 1080"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.path */.E.path, {
                    className: " fill-current text-gray-200",
                    initial: "hidden",
                    animate: show ? "visible" : "hidden",
                    variants: fadeIn,
                    transition: {
                        duration: 0.5
                    },
                    d: "M0,0 l919,919 h-218 l-701,-701 Z",
                    transform: "translate(0 190) rotate(" + rotation + " 459.5 459.5)"
                }),
                sliderBottomSVG_lines.map(function(line, i) {
                    var transform;
                    if (line.rotate) {
                        transform = "translate(" + line.translate.x + " " + line.translate.y + ") rotate(" + rotation + " " + line.x / 2 + " " + line.y / 2 + ")";
                    } else {
                        transform = "translate(" + line.translate.x + " " + line.translate.y + ")";
                    }
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.line */.E.line, {
                        className: (0,clsx_m/* default */.Z)("stroke-current text-primary-main stroke-3"),
                        variants: sliderBottomSVG_animateIn,
                        initial: "hidden",
                        animate: show ? "visible" : "hidden",
                        pathLength: "100",
                        strokeDasharray: "100",
                        transition: {
                            duration: 0.5
                        },
                        fill: "none",
                        x2: line.x,
                        y2: line.y,
                        transform: transform
                    }, i));
                })
            ]
        })
    })));
};
/* harmony default export */ var sliderBottomSVG = (SliderBottomSVG);

// EXTERNAL MODULE: ./src/components/atoms/Link/index.tsx
var Link = __webpack_require__(4357);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(3057);
var ArrowRightIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightIcon);
;// CONCATENATED MODULE: ./src/components/slider/slide.tsx








var Slide = function(props) {
    var show = props.currentSlide === props.data.i && props.loaded;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: show ? "visible" : "hidden",
        variants: {
            hidden: {
                opacity: 0
            },
            visible: {
                opacity: 1
            }
        },
        transition: {
            duration: 0.5,
            delay: 1
        },
        className: (0,clsx_m/* default */.Z)("w-full h-full absolute"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "background-wrapper-top absolute w-full top-0 z-0 flex justify-start overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sliderTopSVG, {
                    className: "flex-grow w-full h-full",
                    rotation: props.data.rotation,
                    show: show
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                className: (0,clsx_m/* default */.Z)("slide-wrapper flex flex-wrap h-full items-center justify-center relative z-10"),
                initial: "hidden",
                animate: "visible",
                variants: {
                    hidden: {
                        opacity: 0
                    },
                    visible: {
                        opacity: 1
                    }
                },
                transition: {
                    duration: 0.5,
                    delay: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full max-w-full font-bold text-primary-main text-center text-6xl leading-none p-7 lg:text-8xl lg:p-10 xl:text-9xl xl:p-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/projects/" + props.data.slug,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: props.data.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute bottom-12 left-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-red",
                                onClick: props.toggleInfo,
                                children: "i"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("absolute w-72 left-1 bottom-full opacity-0 p-5 rounded-sm bg-primary-main text-white", props.data.showInfo && "opacity-100 visible"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: props.data.summary
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/projects/" + props.data.slug,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "project-link uppercase text-white text-xs",
                                            children: [
                                                "View Project",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightIcon_default()), {
                                                    className: "inline-block w-4"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "transition duration-500 absolute w-full bottom-0 z-0 flex justify-start overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sliderBottomSVG, {
                    rotation: props.data.rotation,
                    className: "flex-grow w-full h-full",
                    show: show
                })
            })
        ]
    }));
};
/* harmony default export */ var slider_slide = (Slide);

;// CONCATENATED MODULE: ./src/components/slider/slider.tsx






function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var Slider = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Slider, _Component);
    function Slider(props) {
        _classCallCheck(this, Slider);
        var _this;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
        _this.handleScroll = function(e) {
            var isSidebar = _this.checkIfSidebar(e.path);
            if (!isSidebar) {
                if (e.deltaY < 0) {
                    _this.prevSlide();
                }
                if (e.deltaY > 0) {
                    _this.nextSlide();
                }
            }
        };
        _this.handleTouchStart = function(e) {
            var coords = {
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY
            };
            _this.setState({
                dragged: {
                    coords: coords,
                    active: true
                }
            });
        };
        _this.handleTouchMove = function(e) {
            if (!_this.state.dragged.active) {
                return;
            }
            var newCoords = {
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY
            };
            var startCoords = _this.state.dragged.coords;
            if (newCoords.x - startCoords.x > 100) {
                _this.prevSlide();
            } else if (newCoords.x - startCoords.x < -100) {
                _this.nextSlide();
            }
        };
        _this.handleTouchEnd = function() {
            _this.setState({
                dragged: {
                    coords: {
                        x: null,
                        y: null
                    },
                    active: false
                }
            });
        };
        _this.handleClick = function(e) {
            var dot = e.target;
            _this.gotToSlide(dot.dataset.target);
        };
        _this.gotToSlide = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var target = param === void 0 ? null : param;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        target = parseInt(target, 10);
                        if (!_this.state.animating) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return _this.setState({
                            currentSlide: target,
                            animating: true,
                            showInfo: false
                        });
                    case 5:
                        setTimeout(function() {
                            _this.setState({
                                animating: false
                            });
                        }, 1500);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }).bind(_this)).bind(_assertThisInitialized(_this));
        _this.toggleInfo = function(e) {
            e.preventDefault();
            _this.setState(function(prevState) {
                return {
                    showInfo: !prevState.showInfo
                };
            });
        };
        _this.delayTransition = function(e, slug) {
            e.preventDefault();
            _this.setState({
                loaded: false
            });
            setTimeout(function() {
                return _this.props.router.push("projects/" + slug);
            }, 1000);
        };
        _this.state = {
            animating: false,
            currentSlide: 1,
            dragged: {
                coords: {
                    x: null,
                    y: null
                },
                active: false
            },
            showInfo: false,
            loaded: false
        };
        _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
        _this.prevSlide = _this.prevSlide.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(Slider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                window.addEventListener("wheel", this.handleScroll, {
                    passive: true
                });
                setTimeout(function() {
                    return _this.setState({
                        loaded: true
                    });
                }, 0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("wheel", this.handleScroll);
            }
        },
        {
            key: "checkIfSidebar",
            value: function checkIfSidebar(path) {
                var isSidebar = false;
                path.map(function(item) {
                    if (item.classList === undefined) {
                        return item;
                    }
                    if (item.classList.contains("sidebar")) {
                        isSidebar = true;
                    }
                    return item;
                });
                return isSidebar;
            }
        },
        {
            key: "nextSlide",
            value: function nextSlide() {
                if (this.state.currentSlide === this.props.projects.length) {
                    return;
                }
                if (this.state.animating) {
                    return;
                }
                this.gotToSlide(this.state.currentSlide + 1);
            }
        },
        {
            key: "prevSlide",
            value: function prevSlide() {
                if (this.state.currentSlide === 1) {
                    return;
                }
                if (this.state.animating) {
                    return;
                }
                this.gotToSlide(this.state.currentSlide - 1);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this, _this1 = this;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "slider",
                    className: "relative w-full h-full mx-auto overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-10 h-full",
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onTouchCancel: this.handleTouchEnd,
                            style: {
                                transition: "transform ease-out 0.45s"
                            },
                            children: this.props.projects.map(function(slide, i) {
                                var _this2 = _this;
                                slide.i = i + 1;
                                slide.showInfo = _this.state.showInfo;
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(slider_slide, {
                                    delayTransition: function(e) {
                                        return _this2.delayTransition(e, slide.slug);
                                    },
                                    loaded: _this.state.loaded,
                                    data: slide,
                                    toggleInfo: _this.toggleInfo,
                                    currentSlide: _this.state.currentSlide
                                }, i));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-12 left-24 right-12 z-10 flex flex-wrap justify-center",
                            children: this.props.projects.map(function(slide, i) {
                                var active = false;
                                if (i + 1 === _this1.state.currentSlide) {
                                    active = true;
                                }
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(dot, {
                                    handleClick: _this1.handleClick,
                                    active: active,
                                    count: i
                                }, i));
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return Slider;
}(react.Component);
/* harmony default export */ var slider = ((0,router.withRouter)(Slider));

;// CONCATENATED MODULE: ./src/pages/index.tsx



var Home = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "home",
        className: "relative w-full h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-full w-full p-0 bg-gray-200",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white bg-opacity-80 flex-grow h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(slider, {
                    projects: props.projects
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [666,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);